/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DateRangeActivated,
  DateRangeActivatedOptional,
  DateRangeActivatedMetaI,
  DateRangeActivatedTrackedI,
} from "./date-range-activated";
import {
  DateRangeActivatedTracked,
  DateRangeActivatedMeta,
} from "./date-range-activated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPhoneRef,
  PersonPhoneRefOptional,
  PersonPhoneRefMetaI,
  PersonPhoneRefTrackedI,
} from "./person-phone-ref";
import { PersonPhoneRefTracked, PersonPhoneRefMeta } from "./person-phone-ref";

/**
 *
 * @export
 * @interface PersonPhoneBase
 */
export interface PersonPhoneBaseOptional extends DateRangeActivatedOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneBase
   */
  personPhoneAssignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPhoneBase
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  name?: string;
}

export interface PersonPhoneBase
  extends PersonPhoneBaseOptional, DateRangeActivated, PersonPhoneRef {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneBase
   */
  personPhoneAssignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPhoneBase
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  name?: string;
}

export interface PersonPhoneBaseTrackedI extends DateRangeActivatedOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneBase
   */
  personPhoneAssignId?: number;
  personPhoneAssignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPhoneBase
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPhoneBase
   */
  name?: string;
  nameIsSet: boolean;
}

transformDatesMap.set("PersonPhoneBase", function (model: PersonPhoneBase) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type PersonPhoneBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personPhoneAssignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonPhoneBaseMeta: PersonPhoneBaseMetaI =
  {} as PersonPhoneBaseMetaI;
PersonPhoneBaseMeta = typeMeta("PersonPhoneBase", {
  personPhoneAssignId: propertyMeta(
    "personPhoneAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  name: propertyMeta("name", false, false, false, MetaTypesBase.string),
});

const metaI = PersonPhoneBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonPhoneRefMeta]);
  metaI.personPhoneAssignId.inheritedFrom =
    PersonPhoneRefMeta.personPhoneAssignId;
  metaI.interfaces = metaI.interfaces.concat([DateRangeActivatedMeta]);
  metaI.startActive.inheritedFrom = DateRangeActivatedMeta.startActive;
  metaI.endActive.inheritedFrom = DateRangeActivatedMeta.endActive;
});

export class PersonPhoneBaseTracked
  extends DateRangeActivatedTracked
  implements PersonPhoneBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  personPhoneAssignId__I?: number = undefined;

  get personPhoneAssignIdIsSet() {
    return this.personPhoneAssignId !== undefined;
  }
  set personPhoneAssignIdIsSet(v: boolean) {}
  set personPhoneAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personPhoneAssignId__I = v;
      this.personPhoneAssignIdIsSet = true;
    } else {
      this.personPhoneAssignId__I = v || undefined;
      this.personPhoneAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personPhoneAssignId() {
    return this.personPhoneAssignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = false;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  constructor(config?: PersonPhoneBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (
      this.personPhoneAssignIdIsSet == true &&
      other?.personPhoneAssignIdIsSet == true
    )
      return this.personPhoneAssignId == other.personPhoneAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.personPhoneAssignId) {
      this.personPhoneAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonPhoneBaseOptional,
    options?: AssignOptions,
  ): PersonPhoneBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personPhoneAssignId &&
      this.personPhoneAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personPhoneAssignId = config.personPhoneAssignId;
      if (optionsRequired.unassign) this.personPhoneAssignIdIsSet = false;
      else this.personPhoneAssignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonPhoneBaseTrackedI {
    const cloned = {} as PersonPhoneBaseTrackedI;
    if (
      this.personPhoneAssignIdIsSetDeep() &&
      this.personPhoneAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personPhoneAssignIdIsSet = true;
      cloned.personPhoneAssignId = this.personPhoneAssignId;
    } else {
      //cloned.personPhoneAssignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (!isDeleted(this) && !this.personPhoneAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonPhoneBaseTrackedI {
    if (!this.personPhoneAssignIdApplyFilter(filter))
      this.personPhoneAssignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    return this;
  }
  personPhoneAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneBaseMeta.personPhoneAssignId,
      PersonPhoneBaseMeta,
      this.personPhoneAssignId,
      this,
    );
  }
  personPhoneAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personPhoneAssignIdIsSet &&
      this.personPhoneAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneBaseMeta.startActive,
      PersonPhoneBaseMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneBaseMeta.endActive,
      PersonPhoneBaseMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneBaseMeta.isPrimary,
      PersonPhoneBaseMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneBaseMeta.name,
      PersonPhoneBaseMeta,
      this.name,
      this,
    );
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personPhoneAssignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    if (this.nameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
